import getIcon, { iconOptions as iconOptionsArray } from "./Icons";
export const iconOptions = iconOptionsArray;
export default getIcon;
